// extracted by mini-css-extract-plugin
export var aircallIframe = "_kl-3";
export var fabContainer = "_kl-5";
export var fabRinging = "_kl-6";
export var loadingOverlay = "_kl-4";
export var pulse = "_kl-7";
export var widgetContent = "_kl-2";
export var widgetPanel = "_kl-0";
export var widgetPanelExpanded = "_kl-1";